export function getName(computer) {
  if (computer) {
    if (computer.friendlyName && computer.friendlyName != "")
      return computer.friendlyName;
    else return computer.name;
  }
  return null;
}

export function select(computers, selectedComputers) {
  return computers.map(x => {
    if (selectedComputers.some(y => y.uid === x.uid)) x.selected = true;
    else x.selected = false;
    return x;
  });
}

export default { getName, select };
